// See README.md for more info about field configuration

import { FIELD_TYPE, REFDATA_MAP } from '@/constants'

import _get from 'lodash/get'

export const newHouseHold = {
  name: '',
  age: '',
  relationship: ''
}

export default function getHouseHold(key) {
  return {
    apiKey: key,
   // elemId: houseHoldsScroll,
    type: FIELD_TYPE.COLLECTION,
    collapsible: true,
    showLine: true,
    visible(application) {
      if (application.housing.noOfHouseHold > 0) {
        return true
      }
      return false
    },
    heading(item,index) {
      return `Person  ${index}`
    },
    headingAdd:  'Add New Person',
    headingAddOutline: true,
    //headingAdd: 'Add another Houseing Hold',
    newItem: { ...newHouseHold },
    fields(item, index) {
      var apiKeyPrefix = `housing.houseHolds[${index}]`
            
            return [
              {
                apiKey: `${apiKeyPrefix}.name`,
                label: 'Name',
                placeHolder: 'Enter name',
                type: FIELD_TYPE.NAME,
                maxLength: 100,
                required: true
              },
              {
                apiKey: `${apiKeyPrefix}.age`,
                label: 'Age',
                placeHolder: 'Enter Age',
                type: FIELD_TYPE.NUMBER,
                maxLength: 3,
                required: true,
                validation(value) {
                  if (!/^[0-9]+$/.test(value)) {
                    return `Can only contain numbers`
                  }
                }
              },
              {
                apiKey: `${apiKeyPrefix}.relationship`,
                label: 'Relationship',
                placeHolder: 'Enter Relationship',
                maxLength: 100,
                required: true
              },
              {
                apiKey: `${apiKeyPrefix}.employed`,
                label: 'Employed?',                
                type: FIELD_TYPE.TEXTAREA,
                required: true,
                visible(application) {
                  return application.housing.houseHolds[index].age >= 15    
                }
              }
            ]
          }
    }
  }

